import * as React from 'react'
import { apiAlbumToBPMAlbum } from "src/transformer";
import { GenericClassicSmartViewProps, default as GenericClassicSmartView, GenericClassicSmartViewState, GenericClassicSmartViewHOC } from "./GenericClassicSmartView";
import { ContentType, ListViewHeader } from 'bpm-web-generic';
import { QuerySearchParameters } from 'bpm-client-api';
import { DurationParameters, PagingInfo } from 'bpm-client-api';
import { albumAPI } from 'src/api/config';

export interface TopDownloadsProps extends GenericClassicSmartViewProps {
}
interface TopDownloadsState extends DurationParameters, GenericClassicSmartViewState {
}
class TopDownloadsInner extends GenericClassicSmartView<TopDownloadsProps, TopDownloadsState>{

    constructor(props: TopDownloadsProps) {
        super(props);
        this.changeDuration = this.changeDuration.bind(this)
    }

    componentDidMount() {
        this.setState({ duration: 'monthly' }, () => {
            super.componentDidMount()
        })
    }

    protected hasSmartClassic() {
        return false
    }

    private getCurrentDuration() {
        if (this.state && this.state.duration) {    // State can be null, cause super sets state in constructor and calls getAPIFilter
            return this.state.duration
        }
        return 'monthly'
    }

    private changeDuration(duration: 'daily' | 'monthly' | 'weekly') {
        this.setState({ duration }, () => {
            this.setState({ apiFilter: this.getAPIFilter() }, () => {
                if (this.showCategorizedAlbumView()) {
                    this.setState({ categorized_albums: undefined }, () => this.getAlbumsPerCategory())
                }
            })
        })
    }

    protected getAPIFilter(): QuerySearchParameters {
        let filter = super.getAPIFilter();
        (filter as DurationParameters).duration = this.getCurrentDuration();
        return filter
    }

    protected loadAlbumsForCategory(_: ContentType, filter: QuerySearchParameters, pagingInfo: PagingInfo) {
        return albumAPI.getTrendingAlbumPeriod(this.getCurrentDuration(), pagingInfo.limit, pagingInfo.skip, filter.category, 'music').then((data: any) => {
            return {
                ...data,
                data: data.data.map(apiAlbumToBPMAlbum)
            }
        })
    }

    protected loadAlbums(_: ContentType, filter: QuerySearchParameters, pagingInfo: PagingInfo) {
        return albumAPI.getTrendingAlbumPeriod(this.getCurrentDuration(), pagingInfo.limit, pagingInfo.skip, filter.category, 'music').then((data: any) => {
            return {
                ...data,
                data: data.data.map(apiAlbumToBPMAlbum)
            }
        })
    }

    protected loadAlbumsPerCategory() {
        return this.loadAlbums('audio', this.state.apiFilter, { skip: 0, limit: 120 })
    }

    protected getContext(): string {
        return 'Trends'
    }

    protected getTitle(): string {
        return 'Trends'
    }

    protected renderListViewHeader() {
        return <ListViewHeader
            contentType={this.props.contentType} onContentTypeChange={this.props.onContentTypeChange}
            showDuration onDurationhange={this.changeDuration} duration={this.getCurrentDuration()} />
    }

}
export const TopDownloads = GenericClassicSmartViewHOC(TopDownloadsInner)



// WEBPACK FOOTER //
// ./src/pages/TopDownloads.tsx